//条件参数类
//Field字段名
//Value字段值
//Oper操作 eq等于 neq不等于 contain包含 in被列表包含
//与上一个条件的关系 1and 0or
class Predicate{
    constructor(Field,Value,Oper,IsAnd){
        this.Field = Field;
        this.Value = Value;
        this.Oper = Oper;
        this.IsAnd = IsAnd;
    }
}
export { 
    Predicate
}